export default __webpack_public_path__ + "static/media/astronaut.3c586eb3.svg";